import React from 'react';
interface IConditionalRenderingProps {
    children: React.ReactNode;
    isTrue?: boolean;
}
function ConditionalRendering({
    children,
    isTrue,
}: IConditionalRenderingProps) {
    if (!isTrue) {
        return null;
    }
    return <>{children}</>;
}
export default ConditionalRendering;
